import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

interface Withdrawal {
  id: number;
  created_at?: string;
  valor_cents?: number;
  metodo?: string;
  status?: string;
}

interface Props {
  withdrawals: Withdrawal[];
  formatCurrency: (v: number) => string;
}

function formatDateTime(value?: string) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function WithdrawalsTable({ withdrawals, formatCurrency }: Props) {
  return (
    <Table>
      <TableHeader>
        <TableRow className="bg-muted/50">
          <TableHead>Data</TableHead>
          <TableHead>Valor</TableHead>
          <TableHead>Método</TableHead>
          <TableHead>Status</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {withdrawals.length === 0 ? (
          <TableRow>
            <TableCell colSpan={4} className="py-8 text-center text-muted-foreground">
              Nenhum saque solicitado
            </TableCell>
          </TableRow>
        ) : (
          withdrawals.map((s) => (
            <TableRow key={s.id} className="transition-colors hover:bg-muted/30">
              <TableCell className="font-medium">{formatDateTime(s.created_at)}</TableCell>
              <TableCell className="font-700">{formatCurrency(Number(s.valor_cents ?? 0))}</TableCell>
              <TableCell>{(s.metodo || "-").toUpperCase()}</TableCell>
              <TableCell>
                <Badge className="bg-forest/15 text-forest border-0">
                  {s.status ? s.status.charAt(0).toUpperCase() + s.status.slice(1) : "-"}
                </Badge>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}